<template>
  <b-modal id="modal-request-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-calendar"></em> Compensation day Request</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Leave Date</label>
                <div class="col-8 mb-3">
                  <div class="row">
                    <div class="col-sm-5 mb-1">
                      Date
                    </div>
                    <div class="col-sm-4 mb-1">
                      Time
                    </div>
                    <template  v-for="(item, i) in items">
                      <div class="col-sm-5 mb-1">
                        {{item.date}}
                      </div>
                      <div class="col-sm-4 mb-1">
                        {{item.hours}}
                      </div>
                    </template>

                  </div>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project</label>
                <div class="col-md-6 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Note</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">PIC when leave</label>
                <div class="col-md-6 mb-3">
                  {{detail.contact_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-6 mb-3">
                  {{detail.comp_stat_name}}
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.comp_stat_id)"></list-supervisor-finish>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal,BForm} from 'bootstrap-vue'
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";
export default {
  name: "CompensatoryDetail",
  components:{
    ListSupervisorFinish,
    ListSupervisor,
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      emp_name:"",
      detail:{},
      items:[],
      list_supervisor:[],
      arr_status:[0,1]
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        this.getDetail()
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.detail = {}
      this.$refs.modal.hide()
    },
    getDetail(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.compensatory.detail).then(res=>{
        if (res.success){
          this.detail = res.atributes
          this.items = JSON.parse(res.atributes.items)
          if(!this.arr_status.includes(res.atributes.comp_stat_id)) this.getListSupervisor()
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(e)
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getListSupervisor(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.compensatory.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  },
  mounted() {
    let userProfile = this.$store.getters.userProfile.data.attributes
    this.emp_name = userProfile.emp_name
  }
}
</script>